import { api } from "../../utils/api";

export async function getWhatsappConnections() {
  try {
    const response = await api.get(`/v2/whatsapp`);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar conexões do WhatsApp:", error);
    throw error;
  }
}
